import React from 'react';
import { createPortal } from 'react-dom';
import { CONSTANTS } from '../data.js';
import { useGameDataContext, useDragOverlayContext } from '../app/GameProviders';

interface Props {
  active: boolean;
  itemId: string | null;
  instanceId: string | null;
  x: number;
  y: number;
}

export function WorkbenchDragOverlay({ active, itemId, x, y }: Props) {
  const { MATERIALS } = useGameDataContext();
  const { workbenchOverlayRef } = useDragOverlayContext();

  if (!active || !itemId) return null;

  const material = MATERIALS[itemId];
  if (!material) {
    throw new Error(`WorkbenchDragOverlay: MATERIALS entry missing for id=${itemId}`);
  }

  const size = CONSTANTS.WORKBENCH_ITEM_SIZE;
  const tx = Math.round(x - size / 2);
  const ty = Math.round(y - size / 2);

  const style: React.CSSProperties = {
    position: 'fixed',
    left: 0,
    top: 0,
    transform: `translate3d(${tx}px, ${ty}px, 0)`,
    width: `${size}px`,
    height: `${size}px`,
    zIndex: 99999,
    pointerEvents: 'none',
    willChange: 'transform',
    backfaceVisibility: 'hidden',
    WebkitFontSmoothing: 'auto',
    MozOsxFontSmoothing: 'auto',
    textRendering: 'optimizeSpeed'
  };

  return createPortal(
    <div
      ref={workbenchOverlayRef}
      style={style}
      className="rounded-xl border-2 bg-cyan-500/20 border-cyan-400 flex flex-col items-center justify-center p-2"
    >
      <span className="text-4xl mb-1">{material.icon}</span>
      <span className="text-sm text-center leading-tight">{material.name}</span>
    </div>,
    document.body
  );
}
